import { normalizeCurrency } from './conversion'

export const roundPriceAmount = (amount, decimalPlaces = 2) => {
  const numeric = Number(amount)
  if (!Number.isFinite(numeric)) return null
  const factor = 10 ** decimalPlaces
  return Math.round((numeric + Number.EPSILON) * factor) / factor
}

export const formatPriceInputValue = (amount, decimalPlaces = 2) => {
  const rounded = roundPriceAmount(amount, decimalPlaces)
  if (rounded === null) return ''
  return rounded.toFixed(decimalPlaces)
}

export const formatCurrencyAmount = (amount, currency, options = {}) => {
  const numeric = Number(amount)
  if (!Number.isFinite(numeric)) {
    return options.fallback || 'N/A'
  }

  const normalized = normalizeCurrency(currency)

  try {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: normalized,
      minimumFractionDigits: options.minimumFractionDigits ?? 2,
      maximumFractionDigits: options.maximumFractionDigits ?? 2,
    }).format(numeric)
  } catch (_error) {
    try {
      return new Intl.NumberFormat('en-CA', {
        minimumFractionDigits: options.minimumFractionDigits ?? 2,
        maximumFractionDigits: options.maximumFractionDigits ?? 2,
      }).format(numeric)
    } catch (_nestedError) {
      return options.fallback || 'N/A'
    }
  }
}
